import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from './ui';

const Tasks = () => {
  const navigate = useNavigate();

  const primaryTasks = [
    {
      icon: '👤',
      title: 'Invite a team member',
      desc: 'Add someone to your team so they can access your company\'s applications.',
      route: '/tasks/onboard-user',
    },
    {
      icon: '�',
      title: 'Manage team access',
      desc: 'View your team members, change their roles, or remove them from your company.',
      route: '/team',
    },
    {
      icon: '🚪',
      title: 'Remove a team member',
      desc: 'Remove someone from your company when they leave or change roles. Their account is not deleted.',
      route: '/tasks/offboard-user',
    },
  ];

  const TaskCard = ({ task, primary }) => (
    <div
      className={`bg-white border border-gray-100 rounded-2xl hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 cursor-pointer group shadow-sm ${
        primary ? 'p-6' : 'px-5 py-4'
      }`}
      onClick={() => navigate(task.route)}
    >
      <div className="flex items-start mb-3">
        <div className={`rounded-xl bg-gray-50 border border-gray-100 group-hover:border-primary-light flex items-center justify-center text-2xl mr-4 transition-all shadow-inner ${
          primary ? 'w-12 h-12' : 'w-10 h-10 text-xl'
        }`}>
          {task.icon}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className={`font-bold text-gray-800 tracking-tight group-hover:text-primary transition-colors ${
            primary ? 'text-base mb-1' : 'text-sm mb-0.5'
          }`}>{task.title}</h3>
          <p className="text-xs text-gray-500 leading-relaxed">{task.desc}</p>
        </div>
      </div>
      {primary && (
        <div className="flex justify-end">
          <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary group-hover:text-primary-hover transition-colors">
            Get started
            <svg className="w-3 h-3 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </span>
        </div>
      )}
    </div>
  );

  return (
    <PageLayout
      title="Team Tasks"
      subtitle="Manage your team members and their access to applications."
    >
      <div className="space-y-8">
        {/* Primary tasks — large cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {primaryTasks.map((task) => (
            <TaskCard key={task.title} task={task} primary={true} />
          ))}
        </div>


      </div>
    </PageLayout>
  );
};

export default Tasks;
